module.exports = __webpack_public_path__ + "static/media/icn_aethereum.54d70e4e.svg";